﻿export const AppContainerId = 'forelopigUttalelseSkjemaSide';
